import { createNoOpAnalytics, MixpanelAnalytics } from '@rhim/analytics';

import { environment } from '../../environments/environment';
import { FeatureFlag } from '../../settings/featureFlags';

const mixpanelAnalytics =
  environment.isEdgeMode === true || environment.isUnderTest === true
    ? createNoOpAnalytics()
    : new MixpanelAnalytics(
        environment.mixpanelToken,
        {
          isProduction: environment.production,
        },
        {
          record_sessions_percent: environment.experimentalFeatures.includes(FeatureFlag.SessionReplay) ? 100 : 0,
        }
      );

export function initializeAnalytics() {
  mixpanelAnalytics.init();
}

export { mixpanelAnalytics };
